<!-- 签约半页 -->
<template>
  <div
    v-if="showPage"
    class="base-wrapper home-wrapper"
  >
    <img
      class="half-drawer-close"
      src="../../assets/close.png"
      @click="closeSuspend"
    />
    <div
      class="scroll-wrapper"
      :class="{ 'wrapper-with-promo': promoInfo.pageShowPromo }"
    >
      <img
        v-if="openPageData.titleIcon"
        class="title-icon"
        :src="openPageData.titleIcon"
      />
      <div
        v-if="openPageData.isShowInstruction && openPageData.instructionList"
        class="instruction-area"
        @click="setHalfPageSwitchEmun(VisiblePage.instruction)"
      ></div>
      <!-- 服务流程 && 服务说明 -->
      <div class="service-img">
        <img
          v-if="oncePayMultipleOrdersScene && openPageData.multipleOrdersIcon"
          :src="openPageData.multipleOrdersIcon"
        />
        <img
          v-else-if="openPageData.icon || openPageData.iconNosign"
          :src="openPageData.icon || openPageData.iconNosign"
        />
      </div>
      <!-- 扣款账户 -->
      <div class="deduction-wrapper">
        <div class="index-account section">
          <div>扣款顺序</div>
          <div
            class="flex-align"
            @click="showOrderPage"
          >
            <span> 按照设置的顺序扣款 </span>
            <img
              class="arrow-icon"
              src="../../assets/arrow.png"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="container-bottom-info">
      <div
        v-if="promoInfo.pageShowPromo"
        v-expose="{
          id: 'page-show-promo',
          callback: () => {
            pageShowPromoMV();
          },
        }"
        class="promo-content"
        @click="showPromoInfoPage"
      >
        <div class="flex-align promo-info">
          <div class="rounded-triangle"></div>
          <i class="promo-icon"></i>首次开通本单立减<span class="promo-money">{{ promoInfo.promoAmountOfYuan }}</span>
        </div>
      </div>
      <!-- 开通 button -->
      <div class="button-line">
        <vix-button
          class="go-service ellipsis"
          :loading="payBtnLoading"
          @click="btnClick"
        >
          {{ buttonText }}
        </vix-button>
      </div>
      <!-- 相关协议 -->
      <div
        v-if="agreementInfo.length"
        class="paydefer-agreement center"
      >
        <span>点击按钮即同意</span>
        <span
          class="highlight"
          @click="setHalfPageSwitchEmun(VisiblePage.agreement)"
        >
          先用后付相关协议</span
        >
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { bridge, OpenType, env, VisiblePage, getDeductionOrderPageUrl } from '@/common';
import { lx } from '@/analytic';
import { bids, cids } from '@/analytic/lx-constants';
import type { PromoInfoType } from '@/store/constants';

export default Vue.extend({
  name: 'App',
  props: {
    openType: {
      type: Number,
      default: OpenType.IndependenceSign,
    },
    showPage: {
      type: Boolean,
      default: true,
    },
    openPageData: {
      type: Object,
      default: {} as ShowDataType,
    },
    buttonText: {
      type: String,
      default: '',
    },
    payBtnLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 多笔订单一次性支付标识
      oncePayMultipleOrdersScene: env.coreBusinessParams?.oncePayMultipleOrders === '1',
      VisiblePage,
    };
  },
  computed: {
    // 协议文案及链接
    agreementInfo(): AgreementType[] {
      return this.openPageData.agreementInfo || [];
    },
    promoInfo(): PromoInfoType {
      return this.$store.state.paydelaycashier?.promoInfo || {};
    },
  },
  created() {
    // 这一行可以防止 iOS 的 button: active 样式失效
    document.body.addEventListener('touchstart', () => {});
    bridge.setLLButton(() => {}, '');
  },
  methods: {
    // 主按钮点击
    btnClick() {
      this.$emit('btnClick');
    },
    // 设置切换半页
    setHalfPageSwitchEmun(visiblePageEmun: VisiblePage) {
      this.$store.commit('paydelaycashier/setHalfPageSwitchEmun', { halfPageSwitchEmun: visiblePageEmun });
    },
    // 展示扣款顺序弹窗
    showOrderPage() {
      // this.$emit('toggleVisiblePage', VisiblePage.order, link);
      lx.mc(bids.clickOrderBtn, { process_type: -999 }, { cid: cids.index });
      getDeductionOrderPageUrl(this.openPageData.mtPlanId);
    },
    // 展示营销规则页面
    showPromoInfoPage() {
      lx.addTag(
        cids.index,
        {},
        {
          bid: bids.pagePromoMC,
          campaign_id: this.$store.state.paydelaycashier.promoInfo?.lastPromos || '',
        }
      );
      lx.mc(
        bids.pagePromoMC,
        { campaign_id: this.$store.state.paydelaycashier.promoInfo?.lastPromos || '' },
        { cid: cids.index }
      );
      this.setHalfPageSwitchEmun(VisiblePage.promo);
    },
    // 右上角关闭按钮
    closeSuspend() {
      this.$emit('closeSuspend');
    },
    // 营销规则MV
    pageShowPromoMV() {
      lx.mv(
        bids.pagePromoMV,
        { campaign_id: this.$store.state.paydelaycashier.promoInfo?.lastPromos || '' },
        { cid: cids.index }
      );
    },
  },
});
</script>

<style lang="less" scoped>
@import '../../styles/mixin.less';
.home-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #f9f9f9;

  .scroll-wrapper {
    max-height: calc(100vh - 120px);
    max-height: calc(100vh - 120px - constant(safe-area-inset-bottom) - constant(safe-area-inset-top));
    max-height: calc(100vh - 120px - env(safe-area-inset-bottom) - env(safe-area-inset-top));
    overflow-y: auto;
    padding-bottom: 76px;
    .title-icon {
      position: absolute;
      top: -60px;
      right: 32px;
      width: 248px;
      height: auto;
    }
    .instruction-area {
      position: absolute;
      left: 300px;
      top: 100px;
      height: 100px;
      width: 200px;
    }
  }
  .wrapper-with-promo {
    padding-bottom: 140px;
  }

  .service-img {
    display: inline-block;
    margin-bottom: 0.2rem;
    min-height: 4rem;
    font-size: 0;
    img {
      width: 7.5rem;
      height: auto;
    }
  }
  .deduction-wrapper {
    padding: 0 0.32rem;
    .arrow-icon {
      margin: 0;
    }
  }
  .index-account {
    display: flex;
    justify-content: space-between;
    height: 1rem;
    line-height: 1rem;
    font-size: 0.28rem;
    color: @mainText;
    padding: 0 0.3rem 0 0.42rem;
  }
  .section {
    overflow: hidden;
    background: #ffffff;
    border-radius: 0.16rem;
  }
  .container-bottom-info {
    position: relative;
    width: 100%;
    padding: 0 0.32rem;
    background: none;
    padding-bottom: 0.16rem;
    .promo-content {
      position: absolute;
      top: -77px;
      left: 50%;
      transform: translateX(-50%);
      background: #fff1f0;
      border: 1px solid #ffc6c1;
      padding: 0 16px;
      border-radius: 60px;
      font-size: 24px;
      color: #191919;
      line-height: 50px;
      font-weight: 500;
      .promo-icon {
        .backgroundImage('https://p0.meituan.net/travelcube/fad37040c952861773949d9ab38794152477.png');
        display: inline-block;
        height: 28px;
        width: 28px;
        margin-right: 4px;
      }
      .promo-money {
        margin-left: 2px;
        font-size: 24px;
        color: #ff2d19;
        line-height: 24px;
        font-weight: bold;
      }
      .promo-info {
        position: relative;
      }
      .rounded-triangle {
        position: absolute;
        left: 50%;
        bottom: -10px;
        width: 15px;
        height: 15px;
        background-color: #fff1f0;
        border-left: 1px solid #ffc6c1;
        border-bottom: 1px solid #ffc6c1;
        transform: translateX(-50%) rotate(-60deg) skewX(-30deg) scale(1, 0.866);
      }
    }
  }
  .tip {
    opacity: 0.4;
    font-size: 0.24rem;
    color: #000000;
    text-align: center;
    line-height: 0.24rem;
    margin-top: 0.64rem;
  }
  .paydefer-agreement {
    margin-top: 0.2rem;
    line-height: 1;
    font-size: 22px;
    .highlight {
      color: rgba(0, 0, 0, 0.7);
    }
  }
}
</style>
